/**
 * Stable annotation id for the canonical "section-scoped tags" annotation on a `^` heading block.
 * SectionTagEditor writes a single annotation at this id per heading; non-matching block-anchored
 * annotations on the same heading (from other flows) still contribute to section-scoped tag reads
 * but are not modified by the section editor.
 */
export function sectionTagsAnnotationId(headingBlockId: string): string {
  return `sectionTags_${headingBlockId}`
}
